<app-bottom-sheet #sheet ariaLabel="شبکه‌های اجتماعی">
	<ng-template #body>
		<ul class="flex flex-col divide-y divide-stroke-050 py-2" data-cy="menu-social-list">
			@for (link of links; track link.url) {
				<li>
					<a
						class="flex h-12 w-full items-center gap-2 text-3.25 font-medium text-gray-900"
						target="_blank"
						rel="noopener noreferrer"
						[href]="link.url"
						[attr.data-cy]="link.dataCy">
						<ui-icon class="shrink-0 text-gray-950" width="20" height="20" [iconName]="link.icon" />
						<span class="min-w-0 flex-1 truncate text-right">{{ link.title }}</span>
						<ui-icon class="shrink-0 text-gray-500" width="20" height="20" iconName="chevron-left" />
					</a>
				</li>
			}
		</ul>
	</ng-template>
</app-bottom-sheet>
